'use es6';

import KeyMirror from 'react-utils/keyMirror';
import { List } from 'immutable';
import I18n from 'I18n';
import { Networks } from './Constants';
export const FormLocales = KeyMirror({
  EN_US: null,
  IT_IT: null,
  FR_FR: null,
  ES_ES: null,
  ES_LA: null,
  DE_DE: null,
  EN_GB: null,
  PT_BR: null,
  ZH_TW: null,
  ZH_HK: null,
  TR_TR: null,
  AR_AR: null,
  CS_CZ: null,
  DA_DK: null,
  FI_FI: null,
  HE_IL: null,
  HI_IN: null,
  HU_HU: null,
  ID_ID: null,
  JA_JP: null,
  KO_KR: null,
  NB_NO: null,
  NO_NO: null,
  NL_NL: null,
  PL_PL: null,
  PT_PT: null,
  RO_RO: null,
  RU_RU: null,
  SV_SE: null,
  TH_TH: null,
  VI_VN: null,
  ZH_CN: null,
  TL_PH: null,
  MS_MY: null
});
export const LinkedInLocaleToFormLocale = {
  ar_AE: FormLocales.AR_AR,
  cs_CZ: FormLocales.CS_CZ,
  da_DK: FormLocales.DA_DK,
  nl_NL: FormLocales.NL_NL,
  en_US: FormLocales.EN_US,
  tl_PH: FormLocales.TL_PH,
  fr_FR: FormLocales.FR_FR,
  de_DE: FormLocales.DE_DE,
  in_ID: FormLocales.ID_ID,
  it_IT: FormLocales.IT_IT,
  ja_JP: FormLocales.JA_JP,
  ko_KR: FormLocales.KO_KR,
  ms_MY: FormLocales.MS_MY,
  no_NO: FormLocales.NO_NO,
  nb_NO: FormLocales.NB_NO,
  pl_PL: FormLocales.PL_PL,
  pt_BR: FormLocales.PT_BR,
  ro_RO: FormLocales.RO_RO,
  ru_RU: FormLocales.RU_RU,
  es_ES: FormLocales.ES_ES,
  sv_SE: FormLocales.SV_SE,
  th_TH: FormLocales.TH_TH,
  tr_TR: FormLocales.TR_TR
};
export const FormLocaleToLinkedInLocale = Object.keys(LinkedInLocaleToFormLocale).reduce((formToLI, liLocale) => {
  formToLI[LinkedInLocaleToFormLocale[liLocale]] = liLocale;
  return formToLI;
}, {});
const SUPPORTED_LOCALES_BY_NETWORK = {
  [Networks.FACEBOOK]: [FormLocales.EN_US, FormLocales.IT_IT, FormLocales.FR_FR, FormLocales.ES_ES, FormLocales.ES_LA, FormLocales.DE_DE, FormLocales.EN_GB, FormLocales.PT_BR, FormLocales.ZH_TW, FormLocales.ZH_HK, FormLocales.TR_TR, FormLocales.AR_AR, FormLocales.CS_CZ, FormLocales.DA_DK, FormLocales.FI_FI, FormLocales.HE_IL, FormLocales.HI_IN, FormLocales.HU_HU, FormLocales.ID_ID, FormLocales.JA_JP, FormLocales.KO_KR, FormLocales.NB_NO, FormLocales.NL_NL, FormLocales.PL_PL, FormLocales.PT_PT, FormLocales.RO_RO, FormLocales.RU_RU, FormLocales.SV_SE, FormLocales.TH_TH, FormLocales.VI_VN, FormLocales.ZH_CN],
  [Networks.LINKEDIN]: [FormLocales.AR_AR, FormLocales.CS_CZ, FormLocales.DA_DK, FormLocales.NL_NL, FormLocales.EN_US, FormLocales.TL_PH, FormLocales.FR_FR, FormLocales.DE_DE, FormLocales.ID_ID, FormLocales.IT_IT, FormLocales.JA_JP, FormLocales.KO_KR, FormLocales.MS_MY, FormLocales.NO_NO, FormLocales.PL_PL, FormLocales.PT_BR, FormLocales.RO_RO, FormLocales.RU_RU, FormLocales.ES_ES, FormLocales.SV_SE, FormLocales.TH_TH, FormLocales.TR_TR],
  [Networks.ADWORDS]: []
};
export const FormLocaleToHubSpotLocale = {
  [FormLocales.EN_US]: 'en-us',
  [FormLocales.IT_IT]: 'it-it',
  [FormLocales.FR_FR]: 'fr-fr',
  [FormLocales.ES_ES]: 'es-es',
  [FormLocales.ES_LA]: 'es-mx',
  [FormLocales.DE_DE]: 'de-de',
  [FormLocales.EN_GB]: 'en-gb',
  [FormLocales.PT_BR]: 'pt-br',
  [FormLocales.ZH_TW]: 'zh-tw',
  [FormLocales.ZH_HK]: 'zh-hk',
  [FormLocales.TR_TR]: null,
  [FormLocales.AR_AR]: null,
  [FormLocales.CS_CZ]: 'cs',
  [FormLocales.DA_DK]: 'da-dk',
  [FormLocales.FI_FI]: 'fi-fi',
  [FormLocales.HE_IL]: null,
  [FormLocales.HI_IN]: null,
  [FormLocales.HU_HU]: null,
  [FormLocales.ID_ID]: null,
  [FormLocales.JA_JP]: 'ja-jp',
  [FormLocales.KO_KR]: 'ko-kr',
  [FormLocales.NB_NO]: 'no-no',
  [FormLocales.NO_NO]: 'no-no',
  [FormLocales.NL_NL]: 'nl-nl',
  [FormLocales.PL_PL]: 'pl-pl',
  [FormLocales.PT_PT]: 'pt-pt',
  [FormLocales.RO_RO]: null,
  [FormLocales.RU_RU]: null,
  [FormLocales.SV_SE]: 'sv-se',
  [FormLocales.TH_TH]: null,
  [FormLocales.VI_VN]: null,
  [FormLocales.ZH_CN]: 'zh-cn',
  [FormLocales.TL_PH]: null,
  [FormLocales.MS_MY]: null
};
export const getFormLocaleOptions = network => List(SUPPORTED_LOCALES_BY_NETWORK[network]).map(locale => ({
  value: locale,
  text: I18n.text(`creation.form.creation.formLocales.${locale}`)
})).sortBy(locale => locale.text).toArray();
export const getHubspotLocalizedTextOrEmptyString = (message, netLocale) => {
  const hubSpotLocale = FormLocaleToHubSpotLocale[netLocale];

  if (hubSpotLocale) {
    return I18n.text(message, {
      locale: hubSpotLocale
    });
  } else {
    return '';
  }
};
export const getDefaultLocaleFromHubSpotLocale = (network, hsLocale) => {
  const reformattedLocale = hsLocale.toUpperCase().replace('-', '_');
  const validLocales = SUPPORTED_LOCALES_BY_NETWORK[network];

  if (validLocales.includes(reformattedLocale)) {
    return FormLocales[reformattedLocale];
  }

  const langCode = reformattedLocale.substr(0, 2);
  const langLocale = validLocales.find(locale => locale.substr(0, 2) === langCode);

  if (langLocale) {
    return langLocale;
  } // All locales we support for date and number format but don't provide translations for,
  // we fall back to English. Therefore we should do that here as well.


  return FormLocales.EN_US;
};